<ng-content select="ss-www-step-header"></ng-content>
<div class="max-w-xl mx-auto">
  <ng-content></ng-content>
</div>
